import axiosInstance from '@/utils/axios';

const actions = {
  getSources() {
    return axiosInstance.get('/customer-sources');
  },
  createSource(name) {
    return axiosInstance.post('/customer-sources', { name });
  },
  deleteSource(id) {
    return axiosInstance.delete(`/customer-sources/${id}`);
  },
  getCustomers(params) {
    return axiosInstance.get('/customer-sources/customers/list', { params });
  },
  assignSource(customerId, sourceId) {
    return axiosInstance.patch(`/customer-sources/customers/${customerId}`, { source_id: sourceId });
  },
};

export default { actions };
